import React from 'react';

import Button from '../../../../Button';

export default function UseThisAccountButton({
  loanBankAccountId,
  bankAccount,
  isPending,
  onClick,
  isLender,
  isVendor,
}) {
  return (
    <div className="flex">
      {loanBankAccountId === bankAccount.id || isLender || isVendor ? (
        <div>
          <div className="text-xs inline-flex font-medium rounded-full text-center px-2.5 py-1 bg-emerald-100 dark:bg-emerald-400/30 text-emerald-600 dark:text-emerald-400">
            {bankAccount.status === 'archived' ? 'Archived' : 'Primary'}
          </div>
        </div>
      ) : (
        <Button
          onClick={onClick}
          variant="success"
          className="py-0 text-xs mr-10"
          disabled={isPending}
        >
          Use this account
        </Button>
      )}
    </div>
  );
}
